// The Theme Case's opening (spec web/case-art, web/case-art-images): it shakes, its closed art gives
// way to the open art as light pours out, and then the reel comes out of it. This module is the
// model: each beat is a Web Animations keyframe list on one part of the case, timed from the press
// of "Open case".

/** The case's parts that move: the whole case, its closed and its open art, and the light. */
export type Part = "case" | "closed" | "open" | "light";

export interface Beat {
  part: Part;
  keyframes: Keyframe[];
  delay: number;
  duration: number;
  easing: string;
}

/** The shake, before the lid gives. */
export const SHAKE_MS = 320;

/** When the lid gives (the closed art gives way to the open art), and its latch sounds. */
export const LID_AT_MS = SHAKE_MS;

/** How long the closed art takes to give way to the open art. */
export const SWAP_MS = 180;

/** The whole opening: the reel comes out after it, once the server's draw is back too. */
export const OPENING_MS = 820;

export const OPENING: readonly Beat[] = [
  {
    part: "case",
    delay: 0,
    duration: SHAKE_MS,
    easing: "ease-in-out",
    keyframes: [
      { transform: "rotate(0deg)" },
      { transform: "rotate(-4deg)" },
      { transform: "rotate(4deg)" },
      { transform: "rotate(-3deg)" },
      { transform: "rotate(2deg)" },
      { transform: "rotate(0deg)" },
    ],
  },
  {
    part: "closed",
    delay: LID_AT_MS,
    duration: SWAP_MS,
    easing: "ease-out",
    keyframes: [
      { opacity: 1, transform: "scale(1)" },
      { opacity: 0, transform: "scale(1.04)" },
    ],
  },
  {
    part: "open",
    delay: LID_AT_MS,
    duration: SWAP_MS,
    easing: "ease-out",
    keyframes: [
      { opacity: 0, transform: "scale(0.97)" },
      { opacity: 1, transform: "scale(1)" },
    ],
  },
  {
    part: "light",
    delay: LID_AT_MS,
    duration: OPENING_MS - LID_AT_MS,
    easing: "ease-out",
    keyframes: [
      { opacity: 0, transform: "scale(0.6)" },
      { opacity: 1, transform: "scale(1)", offset: 0.4 },
      { opacity: 0.9, transform: "scale(1.08)" },
    ],
  },
];
